import { render, staticRenderFns } from "./UpsellSetListsConfirm.vue?vue&type=template&id=25cfaf19&"
import script from "./UpsellSetListsConfirm.vue?vue&type=script&lang=js&"
export * from "./UpsellSetListsConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports